export const NotFound = () => {
  return (
    <div className="flex flex-col justify-center gap-5 pt-[4.4rem] pb-6 pl-2 pr-2 w-full h-screen bg-white md:pt-6 md:pr-5 md:pl-[11.5rem] lg:pl-[12.25rem]">
      <h1 className="text-center font-bold text-3xl">
        404
        <br />
        Not Found
      </h1>
      <p className="text-center">The page you are looking for does not exist</p>
    </div>
  );
};
